<template>
  <v-row class="video">
    <v-col cols="12" md="10" offset-md="1">
      <h2>
        Vous avez franchi une étape&#8239;!<br />Ein Meilenstein ist geschafft!
      </h2>
      <div class="video-wrapper">
        <video
          class="video-video"
          width="100%"
          poster="@/assets/img/defr_ceremonie_deformation.jpg"
          :controls="isPlaying"
          @click="play"
          id="ceremonie"
        >
          <source src="@/assets/video/defr_ceremonie.mp4" type="video/mp4" />
        </video>
        <img v-if="!isPlaying" class="video-play" src="@/assets/img/play.svg" />
      </div>
      <div class="video-copyright">
        {{ $t('home.video_credits') }} | Take off productions
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      isPlaying: false
    }
  },
  methods: {
    play() {
      this.isPlaying = true
      setTimeout(() => {
        document.getElementById('ceremonie').play()
      }, 200)
    }
  }
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.video {
  margin-top: 267px;
  z-index: 1;
  position: relative;

  h2 {
    margin-bottom: 0.5em;
  }

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    margin-top: 100px;
  }
}

.video-video {
  cursor: pointer;
  box-shadow: 3px 3px 41px 7px rgba(0, 0, 0, 0.24);
}

.video-copyright {
  margin-top: 0;
  font-size: 16px;

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    margin-top: 1em;
    font-size: 13px;
    line-height: 1.2;
  }
}

.video-wrapper {
  position: relative;
}

.video-play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  pointer-events: none;

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    width: 50px;
  }
}
</style>
